// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "-" + {"10":"2e8041ca","410":"faf8f68a","771":"0b421aaf","990":"a21082df"}[chunkId] + ".css";
};